import { triggerClsPrefix } from '../../../constants/index';

export const EVENT_VISIBLE_CHANGE = `${triggerClsPrefix}-visible-change`;